import { Form, Formik } from "formik";
import * as Yup from "yup";
import CurrencyInput from "../../../Form/CurrencyInput";
import { addLancamentoCaixa } from "../../../../services/api";
import { CaixaContext } from "../../../../contexts/caixaContext";
import { useContext, useState } from "react";
import { useTranslation } from 'react-i18next';
import { convertPrice } from "../../../../utils/convertPrice";
import { AuthContext } from "../../../../contexts/auth";
import { FiPlus, FiCheck } from "react-icons/fi";

import { toast } from "react-toastify";

const SuprimentoForm = ({ onClose }) => {
  const { t } = useTranslation('cashRegister');
  const [isSenting, setIsSenting] = useState(false);

  const validationSchema = Yup.object({
    description: Yup.string().required(t('suprimento.validation.descriptionRequired')),
    value: Yup.string().required(t('suprimento.validation.valueRequired')),
  });

  const initialValues = { value: "", description: "" };
  const { caixa, refetch } = useContext(CaixaContext);
  const { user } = useContext(AuthContext);

  process.env.REACT_APP_ISDEVELOP === 'true' && console.log("caixa", caixa);

  const handleSubmit = async (values) => {
    const { value, description } = values;

    try {
      setIsSenting(true);
      await addLancamentoCaixa(
        caixa.id_empresa,
        caixa._id,
        description,
        "Dinheiro",
        convertPrice(value),
        user._id
      );
      onClose();
      refetch();
    } catch (e) {
      if (e.response?.data?.msg) {
        toast(e.response.data.msg, { type: "error" });
      } else {
        toast(t('suprimento.toasts.error'), { type: "error" });
      }
    } finally {
      setIsSenting(false);
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({ errors, handleChange, values }) => (
        <Form>
          <div className="suprimento-card-unique">
            <div className="suprimento-form-header-unique">
              <div className="suprimento-icon-unique">
                <FiPlus />
              </div>
              <h3 className="suprimento-form-title-unique">{t('suprimento.formTitle')}</h3>
            </div>

            <div className="suprimento-input-group-unique">
              <label className="suprimento-label-unique required">
                {t('suprimento.value')}
              </label>
              <CurrencyInput
                className="suprimento-input-unique"
                label="value"
                name="value"
                type="text"
                placeholder={t('suprimento.placeholder')}
              />
            </div>

            <div className="suprimento-input-group-unique">
              <label className="suprimento-label-unique required">
                {t('suprimento.description')}
              </label>
              <textarea
                className="suprimento-input-unique suprimento-textarea-unique"
                placeholder={t('suprimento.descriptionPlaceholder')}
                id="description"
                name="description"
                value={values.description}
                onChange={handleChange}
              />
              {errors.description && (
                <div className="error-message">{errors.description}</div>
              )}
            </div>
          </div>

          <div className="suprimento-actions-unique">
            <button
              className="suprimento-btn-unique suprimento-btn-cancel-unique"
              type="button"
              onClick={onClose}
              disabled={isSenting}
            >
              {t('suprimento.cancel')}
            </button>
            <button
              className="suprimento-btn-unique suprimento-btn-confirm-unique"
              type="submit"
              disabled={isSenting}
            >
              {isSenting ? (
                <div className="modern-loading-container">
                  <div className="modern-loading-spinner"></div>
                  {t('suprimento.processing')}
                </div>
              ) : (
                <>
                  <FiCheck />
                  {t('suprimento.confirm')}
                </>
              )}
            </button>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default SuprimentoForm;
